const FEATURES = [
  {
    icon: 'ri-database-2-line',
    title: '海量片库',
    desc: '聚合飘花电影网、555电影、8090电影网等主流平台高清资源，覆盖电影、电视剧、综艺、动漫全类型，片库超过10万部。',
    color: 'primary',
  },
  {
    icon: 'ri-speed-up-line',
    title: '极速播放',
    desc: '全网CDN智能加速，自适应码率技术，任何网络环境下都能流畅播放，真正做到不缓冲不卡顿。',
    color: 'accent',
  },
  {
    icon: 'ri-refresh-line',
    title: '每日更新',
    desc: '与各大平台同步更新，最新上映电影、热播剧集第一时间上线，追剧不等待，观影零时差。',
    color: 'secondary',
  },
  {
    icon: 'ri-vip-crown-line',
    title: '免费观看',
    desc: '所有内容无需注册会员、无需付费，打开即看。无广告打扰，纯净观影体验，让好内容触手可及。',
    color: 'primary',
  },
];

export default function SectionFeatures() {
  return (
    <section id="features" className="py-10 md:py-14 px-4 md:px-6 bg-background-50">
      <div className="max-w-[1200px] mx-auto">
        <div className="text-center mb-8">
          <h2 className="text-xl md:text-2xl font-bold text-foreground-50 font-heading">
            为什么选择麻花影视
          </h2>
          <p className="mt-2 text-sm text-foreground-500">
            四大核心优势，打造极致观影体验
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {FEATURES.map((feat) => (
            <div
              key={feat.title}
              className="group p-5 md:p-6 rounded-xl bg-background-100 border border-background-300/40 hover:border-background-300/70 transition-all cursor-default"
            >
              <div
                className={`w-12 h-12 flex items-center justify-center rounded-xl mb-4 ${
                  feat.color === 'accent'
                    ? 'bg-accent-500/15 text-accent-400'
                    : feat.color === 'secondary'
                    ? 'bg-secondary-500/15 text-secondary-400'
                    : 'bg-primary-500/15 text-primary-400'
                }`}
              >
                <i className={`${feat.icon} text-xl`}></i>
              </div>
              <h3 className="text-sm md:text-base font-bold text-foreground-100 mb-2">
                {feat.title}
              </h3>
              <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">
                {feat.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}